import styled from 'styled-components';
import { Media } from 'enums';

export const PaginationWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media ${Media.notebook} {
    justify-content: center;
    column-gap: 18px;
  }
`;

export const PaginationArrowBoxLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media ${Media.notebook} {
    column-gap: 18px;
  }
`;

export const PaginationArrowBoxRight = styled(PaginationArrowBoxLeft)`
  justify-content: flex-end;
`;

export const PaginationItemBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${Media.notebook} {
    column-gap: 18px;
  }
`;
